<template>
  <b-modal
    title="Edycja"
    v-model="showModal"
    ok-title="Zapisz"
    cancel-title="Anuluj"
    ok-variant="outline-primary"
    cancel-variant="outline-secondary"
    @ok.prevent="editNode"
    @hidden="$emit('cancel')"
  >
    <b-form>
      <app-input :model="$schema.name"></app-input>
    </b-form>
  </b-modal>
</template>

<script>
import { LogicalStructureResource } from '@/resources/logicalStructure.resource';
import schema from '@/schemas/logicalStructure.schema';
import formMixin from '@/mixins/formMixin';

export default {
  mixins: [formMixin],
  props: {
    show: Boolean,
    node: Object
  },
  schema,
  data() {
    return {
      showModal: false
    };
  },
  methods: {
    async editNode() {
      if (this.$schema.$validateAll().length === 0) {
        try {
          await LogicalStructureResource.update(this.node.id, this.$schema.name.$value);
          this.$emit('edited', { id: this.node.id, name: this.$schema.name.$value });
          this.$schema.$reset();
        } catch (error) {
          console.warn(error);
          this.$notify({ type: 'error', title: 'Błąd', text: 'Wystąpił błąd podczas aktualizacji węzła' });
        }
      }
    }
  },
  beforeMount() {
    this.showModal = this.show;
    if (this.node) {
      this.$schema.name.$value = this.node.name;
    }
  }
};
</script>

<style></style>
